import React from "react";
import clsx from "clsx";
import { Badge, Text } from "@merge-api/merge-javascript-shared";
import { File, Globe } from "lucide-react";
import {
  LinkedAccountKnowledgeBaseFilter,
  LinkedAccountSyncSelectionTypes,
} from "../../../../../../../../models/Entities";
import { toTitleCase } from "../../../../../../settings/billing/BillingUtils";
import { NAME_COLUMN_CLASS, STATUS_COLUMN_CLASS, TYPE_COLUMN_CLASS } from "../constants";
import UpdatedCell from "./UpdatedCell";
import EmptyCellValue from "./EmptyCellValue";

interface Props {
  selection: LinkedAccountKnowledgeBaseFilter;
}

const KnowledgeBaseSyncSelectionRow = ({ selection }: Props) => {
  // derived state
  const isContainer = selection.type.toUpperCase() === LinkedAccountSyncSelectionTypes.CONTAINER;
  const Icon = isContainer ? Globe : File;

  // render
  return (
    <>
      {/* Name cell contains customer-tenant content and is thus masked at the cell */}
      <div role="cell" title={selection.name} className={clsx(NAME_COLUMN_CLASS, "ph-no-capture")}>
        <Icon size={16} className="shrink-0 text-gray-40" />
        <Text className="min-w-0 truncate">{selection.name}</Text>
      </div>
      <div role="cell" className={TYPE_COLUMN_CLASS}>
        {selection.display_type ? (
          <Badge color={isContainer ? "gray" : "blue"}>{selection.display_type}</Badge>
        ) : (
          <EmptyCellValue />
        )}
      </div>
      <div role="cell" className={STATUS_COLUMN_CLASS}>
        {selection.status ? <Text>{toTitleCase(selection.status)}</Text> : <EmptyCellValue />}
      </div>
      <UpdatedCell updatedAt={selection.updated_at} />
    </>
  );
};

export default KnowledgeBaseSyncSelectionRow;
